export default __webpack_public_path__ + "static/usecasesbg-f10c2945e518d7f1fa44b7430ccf94ee.mp4";